import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import Text from '@/components/view/atoms/text/Text'
import { TextColor } from '@/components/view/atoms/text/Text'

export const CaptionType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  CRITICAL: 'critical',
  CAUTION: 'caution',
  SUCCESS: 'success',
  DISABLED: 'disabled'
} as const
export type CaptionType = (typeof CaptionType)[keyof typeof CaptionType]

interface Props extends ChildProps {
  type?: CaptionType
  size?: 12 | 14
  truncate?: boolean
  noMargin?: boolean
}

const FormCaption = ({
  children,
  type = CaptionType.PRIMARY,
  size = 14,
  truncate = false,
  noMargin = false
}: Props) => {
  const textColor =
    type == CaptionType.PRIMARY
      ? TextColor.PRIMARY
      : type == CaptionType.SECONDARY
        ? TextColor.SECONDARY
        : type == CaptionType.CRITICAL
          ? TextColor.CRITICAL
          : type == CaptionType.CAUTION
            ? TextColor.CAUTION
            : type == CaptionType.SUCCESS
              ? TextColor.SUCCESS
              : type == CaptionType.DISABLED
                ? TextColor.DISABLED
                : TextColor.SECONDARY

  const iconColor =
    type == CaptionType.PRIMARY
      ? IconColor.PRIMARY
      : type == CaptionType.SECONDARY
        ? IconColor.SECONDARY
        : type == CaptionType.CRITICAL
          ? IconColor.CRITICAL
          : type == CaptionType.CAUTION
            ? IconColor.CAUTION
            : type == CaptionType.SUCCESS
              ? IconColor.SUCCESS
              : type == CaptionType.DISABLED
                ? IconColor.DISABLED
                : IconColor.SECONDARY

  return (
    <p className={clsx('relative pl-5', !noMargin && 'mt-1')}>
      <span
        className={clsx(
          'absolute left-0 inline-flex items-center',
          truncate ? 'top-0' : 'top-[2px]'
        )}
      >
        <Icon
          color={iconColor}
          type={type == CaptionType.SUCCESS ? IconType.SUCCESS : IconType.ERROR}
          line={
            type == CaptionType.PRIMARY ||
            type == CaptionType.DISABLED ||
            type == CaptionType.SUCCESS ||
            type == CaptionType.SECONDARY ||
            type == CaptionType.CAUTION
          }
        />
      </span>
      <Text size={size} color={textColor} lineHeight={120} truncate={truncate}>
        {children}
      </Text>
    </p>
  )
}

export default FormCaption
